import { StyleSheet } from 'aphrodite/no-important';

let styles = {
  base: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    margin: '30px 50px 10px'
  },
  modal: {
    height: '100%'
  }
};

export default StyleSheet.create(styles);



// WEBPACK FOOTER //
// ./src/containers/triggers/Triggers.styles.js